<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> افزودن کاربر جدید </template>
    <BRow>
      <BCol cols="12" md="6">
        <TextInput
          inputId="fullName"
          inputLabel="نام کاربر"
          inputPlaceholder="رضا..."
          v-model="userDetails.fullName"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="userEmail"
          inputLabel="ایمیل کاربر"
          inputPlaceholder="info@example.com"
          v-model="userDetails.email"
          :errorMessage="
            isValidEmail
              ? null
              : 'لطفا یک آدرس ایمیل درست وارد کنید (info@example.com)'
          "
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <CountryCodePicker
          v-model="tempSelectedCountry"
          @getCountryCode="setCountryNumberExample"
        ></CountryCodePicker>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="mobile"
          inputLabel="شماره همراه کاربر"
          :inputPlaceholder="countryNumberExample"
          v-model="userDetails.mobile"
          @input="validatePhoneNumberByCountry"
          :errorMessage="
            isValidNumberForCountry
              ? null
              : `لطفا شماره همراه را با فرمت درست وارد کنید (نمونه: ${countryNumberExample})`
          "
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <RolePicker
          :default-selected-role-id="userDetails.type"
          v-model="userDetails.type"
        ></RolePicker>
      </BCol>
      <BCol cols="12" md="6">
        <StatusPicker v-model="userDetails.status"></StatusPicker>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="userPassword"
          inputLabel="رمز عبور"
          inputPlaceholder="1234..."
          :type="passwordFieldType"
          v-model="userDetails.password"
        >
          <template #append>
            <feather-icon
              class="cursor-pointer"
              :icon="passwordToggleIcon"
              @click="togglePasswordVisibility"
            />
          </template>
        </TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          v-model="passwordConfirmation"
          inputId="userPasswordRepeat"
          inputLabel="تکرار رمز عبور"
          inputPlaceholder="1234..."
          :type="passwordFieldType"
          :errorMessage="
            doesPasswordsMatch ? null : 'رمز عبور و تکرار آن باید یکی باشد'
          "
        >
          <template #append>
            <feather-icon
              class="cursor-pointer"
              :icon="passwordToggleIcon"
              @click="togglePasswordVisibility"
            />
          </template>
        </TextInput>
      </BCol>

      <BCol cols="12" v-if="userDetails.type == 3">
        <PriceCategoryPicker
          :isMultiple="true"
          @getPriceCategory="setPriceCategory"
        ></PriceCategoryPicker>
      </BCol>
      <BCol cols="12">
        <div class="w-100 d-flex align-items-center justify-content-end">
          <BButton
            :disabled="isCreateButtonDisabled"
            variant="success"
            @click="sendUserCreateRequest"
          >
            ایجاد کاربر
          </BButton>
        </div>
      </BCol>
    </BRow>
  </PageWrapper>
</template>
<script>
// TODO : Handle errors

export default {
  mounted() {
    this.getAllRoles();
  },

  data() {
    return {
      countryNumberExample: "09121234567",
      isValidNumberForCountry: true,
      tempSelectedCountry: {
        id: 10222,
        name: "Iran",
        flag: "https://flagcdn.com/ir.svg",
        countryCode: "+98",
        isoCode: "IR",
      },
      passwordConfirmation: null,
      numberRegEx:
        /(0){1}?([ ]|-|[()]){0,2}9[0|1|2|3|4|9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/gi,
      emailRegex: /^\S+@\S+\.\S+$/,
      isShowingPassword: false,
      isLoading: false,
      userDetails: {
        isDeleted: false,
        userId: 0,
        fullName: null,
        email: null,
        mobile: null,
        type: 4,
        status: 1,
        password: null,
        userName: null,
        nationalId: null,
        sexuality: 1,
        userCode: null,
        introducerCode: null,
        birthDate: null,
        biography: null,
        createDate: new Date(Date.now()),
        selfieFileData: null,
        bannerFileData: null,
        userRoleAccesses: null,
        isShow: true,
        priceCategoryIds: [],
      },
      rolesList: [],
      statusOptions: [
        {
          text: "فعال",
          value: 1,
        },
        {
          text: "غیر فعال",
          value: 0,
        },
      ],
      typeOptions: [],
    };
  },
  methods: {
    setPriceCategory(priceCategoryIds) {
      this.userDetails.priceCategoryIds = priceCategoryIds;
    },
    togglePasswordVisibility() {
      this.isShowingPassword = !this.isShowingPassword;
    },
    async getAllRoles() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllUserTypes = new GetAllUserTypes(_this);
        await getAllUserTypes.fetch(
          function (response) {
            _this.rolesList = response;
            _this.rolesList.forEach((item) => {
              _this.typeOptions.push({
                text: item.title,
                value: item.userTypeId,
              });
            });
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendUserCreateRequest() {
      let _this = this;
      try {
        this.isLoading = true;
        if (this.tempSelectedCountry) {
          this.userDetails.countryCode = this.tempSelectedCountry.isoCode;
        }
        let createASingleUser = new CreateASingleUser(_this);
        createASingleUser.setRequestParamDataObj(_this.userDetails);
        await createASingleUser.fetch(async function (response) {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: `ایجاد شد`,
                icon: "MessageIcon",
                variant: "success",
                text: `کاربر با موفقیت ایجاد شد..`,
              },
            });
            if (_this.userDetails.type == 3) {
              await _this.createASingleMaster(response.data);
            }
            if (_this.userDetails.type == 4) {
              await _this.createASingleStudent(response.data);
            }
            _this.userDetails = {
              isDeleted: false,
              userId: 0,
              fullName: null,
              email: null,
              mobile: null,
              type: 4,
              status: 1,
              password: null,
              userName: null,
              nationalId: null,
              sexuality: 1,
              userCode: null,
              introducerCode: null,
              birthDate: null,
              biography: null,
              createDate: new Date(Date.now()),
              selfieFileData: null,
              bannerFileData: null,
              userRoleAccesses: null,
              isShow: true,
            };
          }
        });
      } catch (error) {
        _this.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `خطا!`,
            icon: "MessageIcon",
            variant: "danger",
            text: `شماره تلفن یا ایمیل تکراری است..`,
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
    async createASingleMaster(userId) {
      // Check if user is not a master
      if (userId) {
        try {
          this.isLoading = true;
          let _this = this;
          let createAMaster = new CreateAMaster(_this);
          createAMaster.setRequestParamDataObj({
            isDeleted: false,
            masterId: 0,
            userId: userId,
            rate: 0,
            rateCount: 0,
            reportCount: 0,
            currentClassesCount: 0,
            closedClassesCount: 0,
            createDate: new Date(Date.now()),
            isActive: true,
            allSetExams: 0,
            allCanceledExams: 0,
          });
          await createAMaster.fetch(
            function (response) {
              return response;
            },
            function (error) {
              console.error(error);
            }
          );
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    async createASingleStudent(userId) {
      try {
        this.isLoading = true;
        let _this = this;
        let createAStudent = new CreateAStudent(_this);
        createAStudent.setRequestParamDataObj({
          isDeleted: false,
          studentId: 0,
          userId: userId,
          lastPassedLessonId: 0,
          nextLessonId: 0,
          createDate: new Date(Date.now()),
          isActive: true,
        });
        await createAStudent.fetch(
          function (response) {
            return response;
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setCountryNumberExample(country) {
      if (country && country.isoCode) {
        const example = getExampleNumber(
          country.isoCode,
          examples
        ).nationalNumber;
        this.countryNumberExample = `${
          example.startsWith("0") ? "" : "0"
        }${example}`;
        if (this.userDetails.mobile) {
          this.validatePhoneNumberByCountry();
        }
      }
    },
    validatePhoneNumberByCountry() {
      const isoCode = this.tempSelectedCountry.isoCode;

      // 2. Parse ONCE with full metadata
      const parsedNumber = parsePhoneNumberFromString(
        this.userDetails.mobile,
        isoCode
      );

      // 3. Get type DIRECTLY from parsed number
      this.isValidNumberForCountry = parsedNumber
        ? parsedNumber.isValid() && parsedNumber.getType() === "MOBILE" // ✅ Direct access
        : false;

      // This is only for (US) numbers
      // for other countries that may not pass getType(),
      // you may need to validate like below or come up with new solution.
      // Check if the phone number type is either "FIXED_LINE_OR_MOBILE" or undefined,
      // and if the country is the United States (US).
      if (
        (parsedNumber.getType() === "FIXED_LINE_OR_MOBILE" ||
          parsedNumber.getType() === undefined) &&
        (parsedNumber.country.toLowerCase() === "us" ||
          parsedNumber.country.toLowerCase() === "ca")
      ) {
        // If the above conditions are met, perform additional validation on the national number:
        // - If the national number is 11 digits long, it must start with "0".
        // - If the national number is 10 digits long, it must NOT start with "0".
        if (
          (parsedNumber.nationalNumber.length === 11 &&
            parsedNumber.nationalNumber.charAt(0) === "0") ||
          (parsedNumber.nationalNumber.length === 10 &&
            parsedNumber.nationalNumber.charAt(0) !== "0")
        ) {
          // If the number meets the length and prefix requirements, mark it as valid.
          this.isValidNumberForCountry = true;
        } else {
          // If the number does not meet the requirements, mark it as invalid.
          this.isValidNumberForCountry = false;
        }
      }
      if (this.isValidNumberForCountry) {
        const parsedInternationalNumber = parsedNumber
          .formatNational()
          .replaceAll(" ", "");
        if (parsedInternationalNumber) {
          this.userDetails.mobile = parsedInternationalNumber;
        }
      }
    },
  },
  computed: {
    passwordFieldType() {
      if (this.isShowingPassword) {
        return "text";
      }
      return "password";
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    doesPasswordsMatch() {
      if (this.userDetails.password && this.passwordConfirmation) {
        if (this.userDetails.password == this.passwordConfirmation) {
          return true;
        }
        return false;
      }
      return true;
    },
    isValidEmail() {
      if (this.userDetails.email != null && this.userDetails.email != "") {
        return this.emailRegex.test(this.userDetails.email);
      }
      return true;
    },

    isCreateButtonDisabled() {
      if (
        this.userDetails.mobile &&
        this.userDetails.email &&
        this.passwordConfirmation &&
        this.isValidEmail &&
        this.isValidNumberForCountry
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    BRow,
    BCol,
    BButton,
    PriceCategoryPicker,
    RolePicker,
    PageWrapper,
    TextInput,
    StatusPicker,
    CountryCodePicker,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import RolePicker from "@/views/components/Roles/RolePicker.vue";
import StatusPicker from "@/views/components/Users/StatusPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CountryCodePicker from "@/views/components/Country/CountryCodePicker.vue";
import { CreateASingleUser } from "@/libs/Api/Users";
import { CreateAMaster } from "@/libs/Api/Master";
import { CreateAStudent } from "@/libs/Api/Student";
import { GetAllUserTypes } from "@/libs/Api/UserType";
import examples from "libphonenumber-js/mobile/examples";
import {
  parsePhoneNumberFromString,
  getExampleNumber,
} from "libphonenumber-js/max";

import { BRow, BCol, BButton } from "bootstrap-vue";
</script>
